import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const SessionManagement = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    // TODO: Implement session data fetching
    const fetchSessions = async () => {
      try {
        setLoading(true);
        // const data = await sessionService.getSessions();
        // setSessions(data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch sessions. Please try again later.');
        console.error('Error fetching sessions:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
        <p>Loading sessions...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <div className="error-content">
          <i className="error-icon fas fa-exclamation-circle"></i>
          <h2>Error Loading Sessions</h2>
          <p>{error}</p>
          <button className="retry-button" onClick={() => window.location.reload()}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Session Management</h1>
        <button className="btn btn-primary">
          <i className="fas fa-plus"></i> Schedule New Session
        </button>
      </div>

      <div className="dashboard-content">
        <div className="filters-section">
          <div className="search-box">
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search sessions..." />
          </div>
          <div className="filter-options">
            <select defaultValue="">
              <option value="">All Status</option>
              <option value="scheduled">Scheduled</option>
              <option value="in-progress">In Progress</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
            </select>
            <input type="date" placeholder="Filter by date" />
          </div>
        </div>

        <div className="sessions-grid">
          {sessions.length === 0 ? (
            <div className="no-data">
              <i className="fas fa-calendar-alt"></i>
              <h2>No Sessions Found</h2>
              <p>Start by scheduling your first session</p>
            </div>
          ) : (
            sessions.map(session => (
              <div key={session.id} className="session-card">
                <div className="session-header">
                  <div className="session-info">
                    <h3>{session.title}</h3>
                    <p>
                      <i className="fas fa-clock"></i>
                      {session.duration} minutes
                    </p>
                  </div>
                  <div className="session-actions">
                    <button className="action-btn edit">
                      <i className="fas fa-edit"></i>
                    </button>
                    <button className="action-btn more">
                      <i className="fas fa-ellipsis-v"></i>
                    </button>
                  </div>
                </div>

                <div className="session-details">
                  <p>
                    <i className="fas fa-calendar"></i>
                    {session.date}
                  </p>
                  <p>
                    <i className="fas fa-user"></i>
                    {session.studentName}
                  </p>
                  <p>
                    <i className="fas fa-tag"></i>
                    {session.topic}
                  </p>
                </div>

                <div className="session-footer">
                  <span className={`status-badge ${session.status.toLowerCase()}`}>
                    {session.status}
                  </span>
                  <div className="session-actions">
                    <button className="join-session-btn">
                      Join Session
                      <i className="fas fa-video"></i>
                    </button>
                    <button className="reschedule-btn">
                      Reschedule
                      <i className="fas fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionManagement; 